/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/settings': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#fff" d="M11.975 5.9l.825-1.575-1.05-1.05-1.575.825c-.225-.15-.525-.225-.825-.3L8.75 2h-1.5l-.6 1.725c-.225.075-.525.15-.75.3L4.325 3.2 3.2 4.325 4.025 5.9c-.15.225-.225.525-.3.75L2 7.25v1.5l1.725.6c.075.3.225.525.3.825L3.2 11.75l1.05 1.05 1.575-.825c.225.15.525.225.825.3L7.25 14h1.5l.6-1.725c.3-.075.525-.225.825-.3l1.575.825 1.05-1.05-.825-1.575c.15-.225.225-.525.3-.825L14 8.75v-1.5l-1.725-.6c-.075-.225-.15-.525-.3-.75zM8 10.25c-1.275 0-2.25-.975-2.25-2.25S6.725 5.75 8 5.75s2.25.975 2.25 2.25-.975 2.25-2.25 2.25z"/>'
  }
})
